import { useId } from "react"

import {
  Button,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@coval/ui"

import { DisplayMenu } from "./DisplayMenu"

export function GroupingDisplay<T extends string>({
  inline = false,
  value,
  onChange,
  options,
  allExpanded,
  onToggleExpanded,
  showExpansion = value !== "none",
}: {
  inline?: boolean
  value: T
  onChange: (value: T) => void
  options: ReadonlyArray<{ key: T; label: string }>
  showExpansion?: boolean
  allExpanded: boolean
  onToggleExpanded: () => void
}) {
  const groupBySelectId = useId()
  const controls = (
    <>
      <div className="space-y-2">
        <Label htmlFor={groupBySelectId}>Group by</Label>
        <Select value={value} onValueChange={(next) => onChange(next as T)}>
          <SelectTrigger id={groupBySelectId} aria-label="Group by">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {options.map((option) => (
              <SelectItem key={option.key} value={option.key}>
                {option.key === "none" ? "No grouping" : option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {showExpansion && (
        <Button type="button" variant="ghost" onClick={onToggleExpanded}>
          {allExpanded ? "Collapse all groups" : "Expand all groups"}
        </Button>
      )}
    </>
  )
  return inline ? (
    controls
  ) : (
    <DisplayMenu
      summary={
        value === "none"
          ? undefined
          : options.find((option) => option.key === value)?.label
      }
    >
      {controls}
    </DisplayMenu>
  )
}
